import { useQuery } from "@tanstack/react-query";

import { UseFetchResourcesByIdsParams, UseFetchResourcesByIdsOptions } from "./types";
import { fetchResourcesByIdsService } from "./service";

export function useFetchResourcesByIdsQuery<T>(
  params: UseFetchResourcesByIdsParams,
  options?: UseFetchResourcesByIdsOptions<T>
) {
  const queryKey = [params.resource, "byIds", params.ids];

  return useQuery({
    queryKey,
    queryFn: async () => fetchResourcesByIdsService<T>(params),
    enabled: params.ids.length > 0,
    staleTime: 60 * 1000,
    ...options,
  });
}
